export default {
  "en": {
    "sales": {
      "actions": {
        "assign_lead": "Assign lead",
        "remove_lead_from_deal": "Remove lead from deal",
        "update_status": "Update status",
        "upload_document": "Upload document"
      },
      "attributes": {
        "status": "Status"
      },
      "labels": {
        "assign_customer": "Assign customer",
        "assign_lead_to_unit": "Assign lead to unit",
        "assigned_by": "Assigned by",
        "contracts": "Contracts",
        "expiry_date": "Reservation expiry date",
        "go_to_unit_part_1": "This unit was sold. If you want to update the status you need to go to the",
        "go_to_unit_part_2": "and unassign the customer there first as a security measure.",
        "interested_leads": "{count} interested leads",
        "internal_note": "Internal note",
        "latest_phase": "Latest phase",
        "lead_existing": "Existing lead",
        "lead_new": "New lead",
        "mark_as_sold": "Mark as sold",
        "not_published_sales_partners": "Not published for sales partners",
        "not_shown_interest": "This lead has not shown interest in any units",
        "note_explainer": "This note is only visible for your team",
        "publish_unit": "Publish 1 unit for all sales partners | Publish {count} units for all sales partners ",
        "published_sales_partners": "Published for sales partners",
        "reserved_by": "Reserved by",
        "reserved_warning": "This unit is currently reserved by {lead_name}. If you mark this unit as sold, this reservation will be canceled.",
        "sales": "Sales",
        "selling_price": "Selling price",
        "sold_date": "Sold at",
        "sorting": {
          "deal_lead_group_name": "Lead",
          "deal_status": "Status",
          "name": "Unit"
        },
        "status": "Status",
        "statuses": {
          "available": "Available",
          "interested": "Interested",
          "lost": "Lost",
          "reserved": "Reserved",
          "sold": "Sold"
        },
        "tab_sales_documents": "Documents",
        "tab_sales_tickets": "Conversations",
        "tab_sales_units": "Units",
        "unit": "Unit",
        "unit_information_page": "unit information page",
        "unit_sales_status_header": "This unit is for sale",
        "unpublish_unit": "Unublish 1 unit for all sales partners | Unublish {count} units for all sales partners ",
        "update_sales_status": "Update unit sales status",
        "upload_sales_doc": "Upload sales document"
      },
      "validation": {
        "already_reserved_sold": "This unit is already reserved for another lead!",
        "already_reserved_sold_info": "If you are sure you want to change the status for the current lead, you first have to change the status of the deal that currently has priority. Once you've changed the status for the other deal, you can come back and safely update the status.",
        "need_sold_date": "Need the date of this sale",
        "reserved_expiry_date": "Need an expiration date for this reservation"
      }
    }
  }
}